import React, { useState, forwardRef, useMemo } from 'react';
import { useLocation } from 'react-router';

import { CardTabs, TabList } from './TabulartStyle';
import { GenericP, GenericDiv } from 'commonStyles';
import Content from '../ContentSection/Content';
import { getActiveContentIndex } from 'UtilityComponents/intergarationUtils';
import CopyData from '../../../../common/copyData/copyData';
import { FlexDiv } from '../../../../../common/Styles';

const Tabular = ({ tabList = [], pageRedirections = false, styles = {}, isCopy, forwardedRef }) => {
	const { pathname } = useLocation();
	const { width, tabWidth: defTabWidth, borderBottom } = styles;
	const activeIndex = useMemo(()=>getActiveContentIndex(tabList, pathname, pageRedirections), [tabList]);

	const [activeTab, setActiveTab] = useState(activeIndex);

	const activeContent = tabList[activeTab]?.content;

	const activeHandler = (tabData, index) => () => {
		if (tabData?.href) {
			window.location.replace(tabData.href);
		}
		setActiveTab(index);
	};
	const tabwidth = useMemo(()=>{
		if (defTabWidth) {
			return defTabWidth;
		}
		const tabLen = tabList.length;
		const defWidth = 100 / tabLen + '%';
		return defWidth;
	}, []);

	return (
		<GenericDiv $width={width}>
			<CardTabs $borderBottom={borderBottom} position='relative' justify='space-between'>
				<FlexDiv $width={isCopy ? 'calc(100% - 100px)' : '100%'} as='ul' justify='flex-start' align='baseline'>
					{tabList.map((tabData, index) => {
						const { tab } = tabData;
						const isActive = activeTab === index;

						return (
							<TabList $width={tabwidth} key={tab} active={isActive} onClick={activeHandler(tabData, index)}>
								<GenericP as='a' color={isActive ? '#FF405D' : '#4a4a4a'} f_weight='900'>{tab}</GenericP>
							</TabList>
						);
					})}

				</FlexDiv>
				{isCopy && <CopyData wrapper={forwardedRef} />}
			</CardTabs>

			{activeContent && <Content ref={forwardedRef} content={activeContent} />}
		</GenericDiv>
	);
};

export default forwardRef((props, ref) => <Tabular {...props} forwardedRef={ref} />);
